import { groupBy } from 'lodash';
import API from 'services/API';
import { moment } from 'utils';

export default function getContactInfo() {
  return API.request({
    method: 'GET',
    url: '/history',
    mapper: function (data) {
      const sortedData = data
        .map((d) => {
          return {
            date: moment(d.date, 'YYYY-MM-DD HH:mm:ss'),
            ip: d.ip,
            message: d.action,
          };
        })
        .sort((d1, d2) => (d1.date.isBefore(d2.date) ? 1 : -1));

      return groupBy(sortedData, (d) => {
        const date = d.date.format('MMMM YYYY');
        return date[0].toUpperCase() + date.slice(1);
      });
    },
  });
}
